
//未使用store
// import Cookies from 'js-cookie'
const common = {
    state: {
        token: localStorage.getItem('access_token') || null,
        appUserType:''
        // roleCode: localStorage.getItem('roleCode') || null,
        // userInfo: localStorage.getItem('userInfo') || null,
        // nickName: localStorage.getItem('nickName') || null,
        // id: localStorage.getItem('id') || null,
        // originaltoken: localStorage.getItem('originaltoken') || null,
        // confirmStatus: false,//401未登录弹框状态统一维护,防止重复弹框
        // addressList:[],
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            localStorage.setItem('access_token',token,{expires:7})
            state.token = token
        },
        DELETE_TOKEN: (state) => {
            localStorage.removeItem('access_token')
            state.token = null
        },
        SET_APPUSERTYPE: (state, appUserType) => {
            state.appUserType = appUserType
        },
        DELETE_APPUSERTYPE: (state) => {
            state.appUserType = null
        },
        // SET_ORIGINALTOKEN: (state, originaltoken) => {
        //     localStorage.setItem('originaltoken',originaltoken,{expires:7})
        //     state.originaltoken = originaltoken
        // },
        // DELETE_ORIGINALTOKEN: (state) => {
        //     localStorage.removeItem('originaltoken')
        //     state.originaltoken = null
        // },
        // SET_ROLECODE: (state, roleCode) => {
        //     localStorage.setItem('roleCode',roleCode,{expires:7})
        //     state.roleCode = roleCode
        // },
        // DELETE_ROLECODE: (state) => {
        //     localStorage.removeItem('roleCode')
        //     state.roleCode = null
        // },
        // SET_USERINFO: (state, userInfo) => {
        //     state.userInfo = userInfo
        // },
        // DELETE_USERINFO: (state) => {
        //     state.userInfo = null
        // },
        // SET_NICKNAME: (state, nickName) => {
        //     localStorage.setItem('nickName', nickName, { expires: 7 })
        //     state.nickName = nickName
        // },
        // DELETE_NICKNAME: (state) => {
        //     localStorage.removeItem('nickName')
        //     state.nickName = null
        // },
        // SET_ID: (state, id) => {
        //     localStorage.setItem('id', id, { expires: 7 })
        //     state.id = id
        // },
        // DELETE_ID: (state) => {
        //     localStorage.removeItem('id')
        //     state.id = null
        // },
        // CONFIRM_TRUE: (state) => {
        //     state.confirmStatus = true
        // },
        // CONFIRM_FALSE: (state) => {
        //     state.confirmStatus = false
        // },
        // SET_ADDRESSLIST: (state, addressList) => {
        //     localStorage.setItem('addressList',addressList,{expires:7})
        //     state.addressList = addressList
        // },
        // DELETE_ADDRESSLIST: (state) => {
        //     localStorage.removeItem('addressList')
        //     state.addressList = []
        // },
    },
    actions: {
        deleteCommonDataAction({commit}){
            commit('DELETE_TOKEN')
            commit('DELETE_APPUSERTYPE')
            // commit('DELETE_ROLECODE')
            // commit('DELETE_NICKNAME')
            // commit('DELETE_ID')
            // commit('DELETE_ADDRESSLIST')
            // commit('DELETE_ORIGINALTOKEN')
        },
        // setTokenAction({ commit }, token) {
        //     commit('SET_TOKEN', token)
        // },
        // deleteTokenAction({ commit }) {
        //     commit('DELETE_TOKEN')
        // }
    }
}
export default common
